/* ===== config.ts — إعدادات الواجهة العامة للإنتاج =====
   نقل حرفي عن pm/config.js. هذا الملف يُحمّل في المتصفح، لذلك يحتوي فقط على
   بيانات عامة: Supabase URL ومفتاح anon المخصص للواجهة. لا تضع هنا service_role
   أو Azure client secret أو RESEND_API_KEY؛ تحفظ هذه في Supabase Secrets /
   Azure Portal فقط.

   الفرق الوحيد عن الأصل: القيم تُقرأ من متغيّرات البيئة حين توجد، وتسقط إلى
   قيم الإنتاج الحالية حين لا توجد — فيعمل المشروع بلا إعداد مسبق تماماً كالأصل. */

const env = import.meta.env;

export const PM_CONFIG = Object.freeze({
  supabase: {
    url: env.VITE_SUPABASE_URL || 'https://cynmufjkxjjbqhkbtygo.supabase.co',
    anonKey:
      env.VITE_SUPABASE_ANON_KEY ||
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImN5bm11ZmpreGpqYnFoa2J0eWdvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODY1NTkwMDcsImV4cCI6MjEwMjEzNTAwN30.YW2J_wkjZP6-hMDRa4Iu0_H1cPdN-WUceNq9o-Ua6bI',
    // الجلسة تُحفظ في المتصفح ويُجدَّد رمزها تلقائياً، فلا تنتهي بإغلاق التبويب
    // ولا بإعادة فتح الصفحة — تسجيل الخروج الصريح وحده ينهيها.
    auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
    // أدنى عمر للجلسة حين يتعذّر التحقق من الخادم (انقطاع شبكة/خطأ عابر):
    // يُعمل بآخر تحقق ناجح خلال هذه المدة بدل إخراج المستخدم.
    // ملاحظة: السقف الأعلى يضبطه Supabase نفسه من
    // Dashboard ← Authentication ← Sessions (Time-box / Inactivity timeout).
    session: { minDays: 7 },
  },
  azure: { provider: 'azure' as const, scopes: 'openid email profile' },
  email: { notificationFunction: 'send-notification-email' },
  /* مسارات الصفحات في التطبيق ذي الصفحة الواحدة: ملف index.html واحد يختار الصفحة
     من المسار (src/app/routes.ts). كانت في الأصل أسماء ملفات (صفحة التطبيق · الدخول ·
     التوقيع)؛ صارت عناوين نظيفة بلا امتداد:
     - app: المسار الافتراضي للتطبيق — يفتحه الدخول الناجح، وهو عنوان عودة مايكروسوفت.
     - login: صفحة الدخول — التحويل عند انتهاء الجلسة و login?auth=… ورابط الدعوة.
     - sign: بوابة التوقيع العامة — روابط البريد sign?t=<رمز>. */
  routes: { app: 'dashboard', login: 'login', sign: 'sign' },
  /* المرحلة 2 — تحميل حسب الصفحة (store/lazyMode.ts): 'off' = الشيفرة الحالية حرفياً (الافتراضي)؛
     'sections' = القوائم من project_summaries (043) وصفحات المشروع من جزئها (045) واللقطة الكاملة في
     الخلفية. لا يُقلب قبل تطبيق 043 و 045 على الخادم. */
  lazyProjects: env.VITE_PMS_LAZY_PROJECTS === 'sections' ? 'sections' : 'off',
});

/* عنوان العودة بعد مصادقة مايكروسوفت: redirectTo = origin + هذا المسار (lib/supabase.ts).
   ثابت واحد عمداً — يجب أن يطابق ما في Supabase ← Authentication ← URL Configuration ←
   Redirect URLs (مثلاً https://pms-react.alber.org.sa/dashboard أو النمط
   https://pms-react.alber.org.sa/**)، وإلا أعاد Supabase المستخدم إلى Site URL بدله.
   عند العودة يحمل العنوان ‎#access_token=…‎ (أو ‎?code=…‎ في تدفق PKCE) فيقرؤه supabase-js
   (detectSessionInUrl) ثم يمسحه بنفسه؛ الموجِّه يقرأ المسار وحده فلا تُفهم الشظية مساراً
   ولا تُمسّ قبل أن يقرأها (src/app/routes.ts · src/app/pageRouter.ts). */
export const OAUTH_REDIRECT_PATH = '/' + PM_CONFIG.routes.app;

export type PMConfig = typeof PM_CONFIG;
